export default "__VITE_ASSET__BdCXwPQr__"